import Vue from 'vue';
import Router from 'vue-router';
import multiguard from 'vue-router-multiguard';

import { EVENT_PARAMETERS, EVENT_TYPES, store } from './store';

const SignUp = () => import('@/components/auth/SignUp');
const SignUpTokenHandler = () => import('@/components/auth/SignUpTokenHandler');
const AuthRegistrationUsingInvitationCode = () =>
  import('@/components/auth/AuthRegistrationUsingInvitationCode');
const SocietyRegistration = () =>
  import('@/components/auth/SocietyRegistration');
const FAQPage = () => import('@/components/faq/FAQPage');
const ResetPassword = () =>
  import('@/components/auth/password/reset/ResetPassword');

import UserLogin from '@/components/auth/UserLogin';
import Dashboard from '@/components/dashboard/Dashboard';
import SurveyHome from '@/components/survey/home/SurveyHome';
import SurveyForm from '@/components/study/form/StudyForm';
import UpdatePriorYearStudy from '@/components/study/UpdatePriorYearStudy';
import SurveyMultiForm from '@/components/SurveyMultiForm';
import SurveyResults from '@/components/survey/results/SurveyResults';
import ExchangeHome from '@/components/exchange/ExchangeHome';
import JobProfileDetails from '@/components/exchange/job-profile-details/JobProfileDetails';
const UserProfile = () => import('@/components/users/profile/UserProfile');

const Admin = () => import('@/components/Admin');
const QuestionnaireList = () =>
  import('@/components/questionnaire/QuestionnaireList');
const QuestionnaireEdit = () =>
  import('@/components/questionnaire/QuestionnaireEdit');
const QuestionList = () => import('@/components/question/List');
const QuestionEdit = () => import('@/components/question/QuestionEdit');
import JobQuestionList from '@/components/job/question/JobQuestionList';
import SocietyCertifyingBoards from '@/components/society/certifying-boards/SocietyCertifyingBoards';
import { logUserEvent } from '@/helpers/LoggerHelper';
const SocietyList = () => import('@/components/society/SocietyList');
const SocietyEdit = () => import('@/components/society/SocietyEdit');
const SocietyMapping = () =>
  import('@/components/society/mapping/SocietyMappingList');
const EditMembers = () =>
  import('@/components/society/edit-members/EditMembers');
const UserList = () => import('@/components/users/UserList');
const SurveyList = () => import('@/components/SurveyList');
const SpecialtyList = () => import('@/components/specialty/SpecialtyList');
const SpecialtyCreate = () => import('@/components/specialty/SpecialtyCreate');
const SpecialtyEdit = () => import('@/components/specialty/SpecialtyEdit');
const SubspecialtyList = () =>
  import('@/components/subspecialty/SubspecialtyList');
const SubspecialtyCreate = () =>
  import('@/components/subspecialty/SubspecialtyCreate');
const SubspecialtyEdit = () =>
  import('@/components/subspecialty/SubspecialtyEdit');
const SettingsList = () => import('@/components/settings/SettingsList');
const SettingEdit = () => import('@/components/settings/SettingEdit');
const MssAdminDashboard = () => import('@/components/mss_admin/dashboard/Main');
const MSSAdminManageMembers = () =>
  import('@/components/mss_admin/manage/members/Main');
const MSSAdminManageSociety = () =>
  import('@/components/mss_admin/manage/society/Main');
const GMAdminInternalPersons = () =>
  import('@/components/gm_admin/internal_person/List');
const QuestionnaireCreate = () =>
  import('@/components/questionnaire/QuestionnaireCreate');
const SocietyCreate = () => import('@/components/society/SocietyCreate');
const GmAdminDashboard = () => import('@/components/gm_admin/dashboard/Main');
const UserAdd = () => import('@/components/users/UserAdd');
const UpdateTemporaryPassword = () =>
  import('@/components/auth/password/UpdateTemporaryPassword');
const UserEmailsByIds = () =>
  import('@/components/users/user-emails/UserEmails');
const Landing = () => import('@/components/landing/Landing');
const RecruiterFaq = () => import('@/components/recruiter/faq/RecruiterFaq');
const RecruiterSignUp = () =>
  import('@/components/recruiter/auth/RecruiterSignUp');
const RecruiterDashboard = () =>
  import('@/components/recruiter/dashboard/RecruiterDashboard');
const RecruiterIco = () => import('@/components/recruiter/ico/IcoBrowser');
const RecruiterIcoNew = () => import('@/components/recruiter/ico/IcoBrowserNew');
const RecruiterIcoReviewDetails = () => import('@/components/recruiter/ico/IcoReviewDetails');
const RecruiterExchange = () =>
  import('@/components/recruiter/exchange/RecruiterExchange');
const RecruiterEditProfile = () =>
  import('@/components/recruiter/RecruiterEditProfile');
const RecruiterReviewJobOpportunityDetails = () =>
  import('@/components/recruiter/RecruiterReviewJobOpportunityDetails');
const RecruiterEmailValidationTarget = () =>
  import('@/components/recruiter/auth/RecruiterEmailValidationTarget');
const RecruiterVerifyEmailToken = () =>
  import('@/components/recruiter/auth/RecruiterVerifyEmailToken');
const CreateEditJobOffer = () =>
  import('@/components/recruiter/exchange/create-job-offer/CreateEditJobOffer');
const RecruiterInform = () =>
  import('@/components/recruiter/inform/RecruiterInform');
const RecruiterJobSummary = () =>
  import('@/components/recruiter/RecruiterJobSummary');
const JobOffersList = () =>
  import('@/components/gm_admin/job-offers/JobOffersList');
const PrePayPage = () =>
  import('@/components/layouts/pre-paywall/PrePaywallPage');
const PrePayDashboard = () =>
  import(
    '@/components/pre-paywall-pages/physician-dashboard/PrePaywallDashboard'
  );
const PrePayWelcome = () =>
  import('@/components/pre-paywall-pages/welcome/PrePaywallWelcome');
const PrePaywallInform = () =>
  import('@/components/pre-paywall-pages/inform/PrePaywallInform');
const PrePaywallShare = () =>
  import('@/components/pre-paywall-pages/share/PrePaywallShare');
const PrePaywallConnect = () =>
  import('@/components/pre-paywall-pages/connect/PrePaywallConnect');

const PrePayRecruiterDashboard = () =>
  import(
    '@/components/pre-paywall-pages/recruiter/PrePaywallRecruiterDashboard'
  );
const PrePayRecruiterWelcome = () =>
  import('@/components/pre-paywall-pages/recruiter/PrePaywallRecruiterWelcome');
const PrePaywallRecruiterInform = () =>
  import('@/components/pre-paywall-pages/recruiter/PrePaywallRecruiterInform');
const PrePaywallRecruiterConnect = () =>
  import('@/components/pre-paywall-pages/recruiter/PrePaywallRecruiterConnect');
const PrePaywallRecruiterIcoBrowser = () =>
  import(
    '@/components/pre-paywall-pages/recruiter/PrePaywallRecruiterIcoBrowser'
  );
const UserPage = () => import('@/components/layouts/user/UserPage');
const SwitchGuestRolesPage = () =>
  import('@/components/pre-paywall-pages/SwitchGuestRolesPage');
const JobInformationSetPage = () =>
  import('@/components/recruiter/job_information_set/JobInformationSetList');

Vue.use(Router);

export const ROUTES = {
  GUEST_SWITCH_ROLES_PAGE: '/who-are-you',
  GUEST_PHYSICIAN_WELCOME_PAGE: '/welcome',
  GUEST_RECRUITER_WELCOME_PAGE: '/welcome/recruiter',
};

const notAuthenticatedOnly = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    return next(userRedirect());
  }
  next();
};

const guestRecruiterOnly = (to, from, next) => {
  if (!store.getters.isGuestRecruiter) {
    return next(ROUTES.GUEST_PHYSICIAN_WELCOME_PAGE);
  }
  next();
};

const authenticatedOnly = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    return next(ROUTES.GUEST_SWITCH_ROLES_PAGE);
  }
  next();
};

const adminOnly = (to, from, next) => {
  if (!store.getters.userIsAdmin) {
    return next(userRedirect());
  }
  next();
};

const mssAdminOnly = (to, from, next) => {
  if (!store.getters.userIsMSSAdmin) {
    return next(userRedirect());
  }
  next();
};

const gmAdminOnly = (to, from, next) => {
  if (!store.getters.userIsGMAdmin) {
    return next(userRedirect());
  }
  next();
};

const simpleUserOnly = (to, from, next) => {
  if (store.getters.userIsAdmin || store.getters.userIsMSSRecruiter) {
    return next(userRedirect());
  }
  if (store.getters.userHasInvalidEmail)
    return next('/recruiter/email-validation');
  next();
};

const mssRecruiterOnly = (to, from, next) => {
  if (!store.getters.userIsMSSRecruiter) {
    return next(userRedirect());
  }
  next();
};

const mssRecruiterOrGmAdmin = (to, from, next) => {
  if (!store.getters.userIsMSSRecruiter && !store.getters.userIsGMAdmin) {
    return next(userRedirect());
  }
  next();
};

const emailInvalidOnly = (to, from, next) => {
  if (!store.getters.userHasInvalidEmail) {
    return next(userRedirect());
  }
  next();
};

const requirePassResetOnly = (to, from, next) => {
  if (!store.state.isPasswordResetRequired) {
    return next(userRedirect());
  }
  next();
};

const userRedirect = () => {
  if (!store.getters.isAuthenticated) {
    return ROUTES.GUEST_SWITCH_ROLES_PAGE;
  }
  if (store.getters.userIsMSSAdmin) {
    return '/mss-admin';
  }
  if (store.getters.userIsGMAdmin) {
    return '/gm-admin';
  }
  if (store.getters.userIsMSSRecruiter) {
    return '/recruiter';
  }
  return '/user/dashboard';
};

const router = new Router({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '*',
      redirect: ROUTES.GUEST_SWITCH_ROLES_PAGE,
    },
    {
      path: '/landing',
      component: Landing,
    },
    {
      path: '/login',
      name: 'Login',
      component: UserLogin,
      beforeEnter: notAuthenticatedOnly,
      meta: { hideNavbarToggle: true },
    },
    {
      path: '/sign-up/:signUpToken',
      name: 'SignUp',
      component: SignUpTokenHandler,
      meta: { hideNavbarToggle: true },
    },
    {
      path: '/registration/:signUpToken?',
      name: 'Registration',
      component: SignUp,
      meta: { hideNavbarToggle: true },
    },
    {
      path: '/auth/reset/confirm/:token',
      name: 'Reset Password',
      component: ResetPassword,
      beforeEnter: notAuthenticatedOnly,
      meta: { hideNavbarToggle: true },
    },
    {
      path: '/memberregistration',
      name: 'Registration Using Invitation Code',
      component: AuthRegistrationUsingInvitationCode,
      beforeEnter: notAuthenticatedOnly,
    },
    {
      path: '/societyregistration/:urlCode?',
      name: 'Registration Using Email',
      component: SocietyRegistration,
      beforeEnter: notAuthenticatedOnly,
    },
    {
      path: '/auth/update-temporary-password',
      name: 'Update Temporary Password',
      component: UpdateTemporaryPassword,
      beforeEnter: requirePassResetOnly,
    },
    {
      path: '/',
      redirect: userRedirect,
    },
    {
      path: '/user',
      component: UserPage,
      meta: {
        breadcrumb: {
          title: 'Home',
        },
      },
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard,
          beforeEnter: multiguard([authenticatedOnly, simpleUserOnly]),
          props: (route) => {
            return {
              initialReferModalVisible: !!route.query['refer-a-colleague'],
            };
          },
          meta: {
            breadcrumb: {
              title: 'Dashboard',
            },
          },
        },
        {
          path: 'surveyHome',
          name: 'Share',
          component: SurveyHome,
          beforeEnter: multiguard([authenticatedOnly, simpleUserOnly]),
          meta: {
            breadcrumb: {
              title: 'Share',
            },
          },
        },
        {
          path: 'filters/:qsId?/:sectionId?',
          name: 'Inform',
          component: SurveyResults,
          beforeEnter: multiguard([authenticatedOnly, simpleUserOnly]),
          props: {
            title: 'Compare Results',
            format: 'filters',
          },
          meta: {
            breadcrumb: {
              title: 'Inform',
            },
          },
        },
        {
          path: 'exchange',
          component: ExchangeHome,
          beforeEnter: multiguard([authenticatedOnly, simpleUserOnly]),
          meta: {
            breadcrumb: {
              title: 'Connect',
            },
          },
        },
      ],
    },
    {
      path: '/help',
      component: FAQPage,
    },
    {
      path: '/profile',
      component: UserProfile,
      beforeEnter: authenticatedOnly,
      meta: {
        breadcrumb: {
          title: 'Edit Profile',
        },
      },
    },
    {
      path: '/surveyHome',
      name: 'studies',
      component: SurveyHome,
      beforeEnter: multiguard([authenticatedOnly, simpleUserOnly]),
    },
    {
      path: '/surveyForm/:surveyId/:sectionId?',
      name: 'surveyForm',
      component: SurveyForm,
      beforeEnter: authenticatedOnly,
    },
    {
      path: '/surveyMultiForm/:surveyIds',
      component: SurveyMultiForm,
      beforeEnter: authenticatedOnly,
    },
    {
      path: '/update-prior-year-study/:surveyId?',
      name: 'UpdatePriorYearStudy',
      component: UpdatePriorYearStudy,
      beforeEnter: authenticatedOnly,
    },
    {
      path: '/exchange',
      component: ExchangeHome,
      beforeEnter: multiguard([authenticatedOnly, simpleUserOnly]),
    },
    {
      path: '/exchange/job-profile/:id',
      name: 'jobProfilePage',
      component: JobProfileDetails,
      beforeEnter: multiguard([authenticatedOnly, simpleUserOnly]),
    },
    {
      path: '/user/exchange/job-profile/:id',
      name: 'jobProfilePage',
      component: JobProfileDetails,
      beforeEnter: multiguard([authenticatedOnly, simpleUserOnly]),
    },

    {
      path: '/admin',
      component: Admin,
      beforeEnter: multiguard([authenticatedOnly, gmAdminOnly]),
    },
    {
      path: '/admin/questionnaire',
      component: QuestionnaireList,
      beforeEnter: multiguard([authenticatedOnly, gmAdminOnly]),
    },
    {
      path: '/admin/questionnaire/create',
      component: QuestionnaireCreate,
      beforeEnter: multiguard([authenticatedOnly, gmAdminOnly]),
    },
    {
      path: '/admin/questionnaire/edit/:questionnaireId',
      component: QuestionnaireEdit,
      beforeEnter: multiguard([authenticatedOnly, gmAdminOnly]),
    },
    {
      path: '/admin/question',
      component: QuestionList,
      beforeEnter: multiguard([authenticatedOnly, gmAdminOnly]),
    },
    {
      path: '/admin/question/edit/:questionId',
      component: QuestionEdit,
      beforeEnter: multiguard([authenticatedOnly, gmAdminOnly]),
    },
    {
      path: '/admin/job-question',
      component: JobQuestionList,
      beforeEnter: multiguard([authenticatedOnly, gmAdminOnly]),
    },
    {
      path: '/admin/specialty',
      component: SpecialtyList,
      beforeEnter: multiguard([authenticatedOnly, gmAdminOnly]),
    },
    {
      path: '/admin/master-specialty',
      component: SpecialtyList,
      props: {
        isMasterList: true,
      },
      beforeEnter: multiguard([authenticatedOnly, gmAdminOnly]),
    },
    {
      path: '/admin/specialty/create',
      component: SpecialtyCreate,
      beforeEnter: multiguard([authenticatedOnly, gmAdminOnly]),
    },
    {
      path: '/admin/master-specialty/create',
      component: SpecialtyCreate,
      props: {
        isMaster: true,
      },
      beforeEnter: multiguard([authenticatedOnly, gmAdminOnly]),
    },
    {
      path: '/admin/specialty/edit/:specialtyId',
      component: SpecialtyEdit,
      beforeEnter: multiguard([authenticatedOnly, gmAdminOnly]),
    },
    {
      path: '/admin/master-specialty/edit/:specialtyId',
      component: SpecialtyEdit,
      props: {
        isMaster: true,
      },
      beforeEnter: multiguard([authenticatedOnly, gmAdminOnly]),
    },
    {
      path: '/admin/subspecialty',
      component: SubspecialtyList,
      beforeEnter: multiguard([authenticatedOnly, gmAdminOnly]),
    },
    {
      path: '/admin/subspecialty/create',
      component: SubspecialtyCreate,
      beforeEnter: multiguard([authenticatedOnly, gmAdminOnly]),
    },
    {
      path: '/admin/subspecialty/edit/:subspecialtyId',
      component: SubspecialtyEdit,
      beforeEnter: multiguard([authenticatedOnly, gmAdminOnly]),
    },
    {
      path: '/admin/master-subspecialty',
      component: SubspecialtyList,
      props: {
        isMasterList: true,
      },
      beforeEnter: multiguard([authenticatedOnly, gmAdminOnly]),
    },
    {
      path: '/admin/master-subspecialty/create',
      component: SubspecialtyCreate,
      props: {
        isMaster: true,
      },
      beforeEnter: multiguard([authenticatedOnly, gmAdminOnly]),
    },
    {
      path: '/admin/master-subspecialty/edit/:subspecialtyId',
      component: SubspecialtyEdit,
      props: {
        isMaster: true,
      },
      beforeEnter: multiguard([authenticatedOnly, gmAdminOnly]),
    },
    {
      path: '/admin/society',
      component: SocietyList,
      beforeEnter: multiguard([authenticatedOnly, gmAdminOnly]),
    },
    {
      path: '/admin/society/create',
      component: SocietyCreate,
      beforeEnter: multiguard([authenticatedOnly, gmAdminOnly]),
    },
    {
      path: '/admin/society/edit/:societyId',
      component: SocietyEdit,
      beforeEnter: multiguard([authenticatedOnly, gmAdminOnly]),
    },
    {
      path: '/admin/society/edit-members/:societyId',
      component: EditMembers,
      beforeEnter: multiguard([authenticatedOnly, gmAdminOnly]),
    },
    {
      path: '/admin/society/mapping/:societyId',
      component: SocietyMapping,
      beforeEnter: multiguard([authenticatedOnly, gmAdminOnly]),
    },
    {
      path: '/admin/society/certifying-boards/:societyId',
      component: SocietyCertifyingBoards,
      beforeEnter: multiguard([authenticatedOnly, gmAdminOnly]),
    },
    {
      path: '/admin/survey',
      component: SurveyList,
      beforeEnter: multiguard([authenticatedOnly, gmAdminOnly]),
    },
    {
      path: '/admin/user',
      component: UserList,
      beforeEnter: multiguard([authenticatedOnly, gmAdminOnly]),
    },
    {
      path: '/admin/user/add',
      component: UserAdd,
      beforeEnter: multiguard([authenticatedOnly, gmAdminOnly]),
    },
    // todo: job preferences is temporary disabled
    // {
    //   path: '/ccRecruiter',
    //   component: CCRecruiterMock,
    //   beforeEnter: authenticatedOnly,
    //   props: {
    //     title: 'Job Preference',
    //     format: 'results',
    //   },
    // },

    /**
     * Internal Persons
     */
    {
      path: '/admin/internal-persons',
      component: GMAdminInternalPersons,
      beforeEnter: multiguard([authenticatedOnly, gmAdminOnly]),
    },

    /**
     * Admin Settings
     */
    {
      path: '/admin/settings',
      component: SettingsList,
      beforeEnter: multiguard([authenticatedOnly, gmAdminOnly]),
    },
    {
      path: '/admin/settings/edit/:key',
      component: SettingEdit,
      beforeEnter: multiguard([authenticatedOnly, gmAdminOnly]),
    },
    {
      path: '/admin/user-emails',
      component: UserEmailsByIds,
      beforeEnter: multiguard([authenticatedOnly, gmAdminOnly]),
    },
    {
      path: '/admin/job-offers',
      component: JobOffersList,
      beforeEnter: multiguard([authenticatedOnly, gmAdminOnly]),
    },

    /**
     * MSS Admin
     */
    {
      path: '/mss-admin',
      component: MssAdminDashboard,
      beforeEnter: multiguard([authenticatedOnly, mssAdminOnly]),
    },
    {
      path: '/mss-admin/manage/members',
      component: MSSAdminManageMembers,
      beforeEnter: multiguard([authenticatedOnly, mssAdminOnly]),
    },
    {
      path: '/mss-admin/manage/society',
      component: MSSAdminManageSociety,
      beforeEnter: multiguard([authenticatedOnly, mssAdminOnly]),
    },
    {
      path: '/mss-admin/manage/members',
      component: MSSAdminManageMembers,
      beforeEnter: multiguard([authenticatedOnly, mssAdminOnly]),
    },
    {
      path: '/view-admin-results/:qsId',
      component: SurveyResults,
      beforeEnter: multiguard([authenticatedOnly, adminOnly]),
      props: {
        title: 'Results',
        format: 'admin-survey-results',
      },
    },

    /**
     * GM Admin
     */
    {
      path: '/gm-admin',
      component: GmAdminDashboard,
      beforeEnter: multiguard([authenticatedOnly, gmAdminOnly]),
    },

    /**
     * MSS Recruiter
     */

    //<editor-fold desc="MSS Recruiter Pages" defaultstate="collapsed">
    {
      path: '/recruiter/sign-up',
      component: RecruiterSignUp,
      beforeEnter: notAuthenticatedOnly,
    },
    {
      path: '/recruiter',
      component: RecruiterDashboard,
      beforeEnter: multiguard([authenticatedOnly, mssRecruiterOnly]),
    },
    {
      path: '/recruiter/faq',
      component: RecruiterFaq,
    },
    {
      path: '/recruiter/ico',
      component: RecruiterIcoNew,
    },
    {
      path: '/recruiter/ico-new',
      component: RecruiterIco,
    },
    {
      path: '/recruiter/ico-review-details',
      component: RecruiterIcoReviewDetails,
      beforeEnter: multiguard([authenticatedOnly, mssRecruiterOnly]),
    },
    {
      path: '/recruiter/exchange',
      component: RecruiterExchange,
      beforeEnter: multiguard([authenticatedOnly, mssRecruiterOnly]),
    },
    {
      path: '/recruiter/inform',
      component: RecruiterInform,
      beforeEnter: multiguard([authenticatedOnly, mssRecruiterOnly]),
    },
    {
      path: '/recruiter/create-job-offer',
      component: CreateEditJobOffer,
      beforeEnter: multiguard([authenticatedOnly, mssRecruiterOnly]),
    },
    {
      path: '/recruiter/edit-job-offer/:joId',
      component: CreateEditJobOffer,
      beforeEnter: multiguard([authenticatedOnly, mssRecruiterOrGmAdmin]),
    },
    {
      path: '/recruiter/profile',
      component: RecruiterEditProfile,
      beforeEnter: multiguard([authenticatedOnly, mssRecruiterOnly]),
    },
    {
      path: '/recruiter/review-job-opportunity',
      component: RecruiterReviewJobOpportunityDetails,
      beforeEnter: multiguard([authenticatedOnly, mssRecruiterOnly]),
    },
    {
      path: '/recruiter/job-summary',
      component: RecruiterJobSummary,
      beforeEnter: multiguard([authenticatedOnly, mssRecruiterOnly]),
    },
    {
      path: '/recruiter/email-validation',
      component: RecruiterEmailValidationTarget,
      beforeEnter: multiguard([authenticatedOnly, emailInvalidOnly]),
    },
    {
      path: '/recruiter/email-verification/:token',
      component: RecruiterVerifyEmailToken,
    },
    //</editor-fold>

    //<editor-fold desc="Job Information Set Pages" defaultstate="collapsed">
    {
      path: '/recruiter/job-information-set',
      component: JobInformationSetPage,
      beforeEnter: multiguard([authenticatedOnly, mssRecruiterOnly]),
    },
    //</editor-fold>

    //<editor-fold desc="PrePaywall Pages" defaultstate="collapsed">
    { // recruiter pages with guards
      path: ROUTES.GUEST_RECRUITER_WELCOME_PAGE,
      component: PrePayPage,
      beforeEnter: notAuthenticatedOnly,
      meta: {
        breadcrumb: {
          title: 'Home',
        },
      },
      children: [
        {
          path: '',
          component: PrePayRecruiterWelcome,
          beforeEnter: notAuthenticatedOnly,
          meta: {
            hideNavbarToggle: true,
            breadcrumb: {
              title: 'Welcome',
            },
          },
        },
        {
          path: 'dashboard',
          component: PrePayRecruiterDashboard,
          beforeEnter: multiguard([notAuthenticatedOnly, guestRecruiterOnly]),
          meta: {
            breadcrumb: {
              title: 'Dashboard',
            },
          },
        },
        {
          path: 'inform',
          component: PrePaywallRecruiterInform,
          beforeEnter: multiguard([notAuthenticatedOnly, guestRecruiterOnly]),
          meta: {
            breadcrumb: {
              title: 'Inform',
            },
          },
        },
        {
          path: 'connect',
          component: PrePaywallRecruiterConnect,
          beforeEnter: multiguard([notAuthenticatedOnly, guestRecruiterOnly]),
          meta: {
            breadcrumb: {
              title: 'Connect',
            },
          },
        },
      ],
    },
    { // recruiter pages without guestRecruiterOnly guard and notAuthenticatedOnly guard
      path: ROUTES.GUEST_RECRUITER_WELCOME_PAGE,
      component: PrePayPage,
      beforeEnter: multiguard([notAuthenticatedOnly]),
      meta: {
        breadcrumb: {
          title: 'Home',
        },
      },
      children: [
        {
          path: 'ico-browser',
          component: PrePaywallRecruiterIcoBrowser,
          meta: {
            breadcrumb: {
              title: 'ICO Browser',
            },
          },
        },
      ],
    },
    {
      path: ROUTES.GUEST_PHYSICIAN_WELCOME_PAGE,
      component: PrePayPage,
      beforeEnter: notAuthenticatedOnly,
      meta: {
        breadcrumb: {
          title: 'Home',
        },
      },
      children: [
        {
          path: '',
          component: PrePayWelcome,
          beforeEnter: notAuthenticatedOnly,
          meta: {
            hideNavbarToggle: true,
            breadcrumb: {
              title: 'Welcome',
            },
          },
        },
        {
          path: 'dashboard',
          component: PrePayDashboard,
          beforeEnter: notAuthenticatedOnly,
          meta: {
            breadcrumb: {
              title: 'Dashboard',
            },
          },
        },
        {
          path: 'share',
          component: PrePaywallShare,
          beforeEnter: notAuthenticatedOnly,
          meta: {
            breadcrumb: {
              title: 'Share',
            },
          },
        },
        {
          path: 'inform',
          component: PrePaywallInform,
          beforeEnter: notAuthenticatedOnly,
          meta: {
            breadcrumb: {
              title: 'Inform',
            },
          },
        },
        {
          path: 'connect',
          component: PrePaywallConnect,
          beforeEnter: notAuthenticatedOnly,
          meta: {
            breadcrumb: {
              title: 'Connect',
            },
          },
        },
      ],
    },
    {
      path: ROUTES.GUEST_SWITCH_ROLES_PAGE,
      component: SwitchGuestRolesPage,
      beforeEnter: multiguard([notAuthenticatedOnly]),
      meta: { hideNavbarToggle: true },
    },
    //</editor-fold>
    {
      path: '/presentation/reports',
      component: SurveyResults,
      props: {
        title: 'Reports',
        format: 'presentation',
      },
    },
  ],
});

router.afterEach((to, from) => {
  if (store.state.user) {
    logUserEvent(EVENT_TYPES.ENTER_PAGE, {
      [EVENT_PARAMETERS.ENTER_PAGE_FROM]: from.path,
      [EVENT_PARAMETERS.ENTER_PAGE_TO]: to.path,
      [EVENT_PARAMETERS.ENTER_PAGE_NAME]: to.name,
    });
  }
});

export default router;
